import { GET_BRITANIA_DETAILS } from "./actions.type";
import { detail } from "@/service/detail";

function initState() {
  return {}
}

const state = initState();

const actions = {
  async [GET_BRITANIA_DETAILS]({ }, data) {
    let response = await detail.getBritaniaDetail(data);
    // console.log(response);
    return response;
  },
};


const mutations = {};

const getters = {};

export default {
  state,
  actions,
  mutations,
  getters
};
